export const REPORT_METRIC_TONES = {
  requestCount: ['var(--accent-red)', 'var(--accent-red-soft)', 'var(--accent-red-border)'],
  exposureCount: ['var(--accent-orange)', 'var(--accent-orange-soft)', 'var(--accent-orange-border)'],
  revenueAmount: ['var(--accent-green)', 'var(--accent-green-soft)', 'var(--accent-green-border)'],
  ecpm: ['var(--accent-purple)', 'var(--accent-purple-soft)', 'var(--accent-purple-border)']
}

// 기존 tone 이름을 사용하는 KPI도 동일한 지표 매핑을 참조합니다.
REPORT_METRIC_TONES.blue = REPORT_METRIC_TONES.requestCount
REPORT_METRIC_TONES.cyan = REPORT_METRIC_TONES.exposureCount
REPORT_METRIC_TONES.green = REPORT_METRIC_TONES.revenueAmount
REPORT_METRIC_TONES.purple = REPORT_METRIC_TONES.ecpm

export const getReportMetricColor = metric => (
  REPORT_METRIC_TONES[metric]?.[0] || REPORT_METRIC_TONES.requestCount[0]
)
